import styled from 'styled-components';

export const ResultWrapper = styled.div`
    border: 1px solid #D5EBD7;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 10px;
`;